import React from "react";
import styled from "styled-components";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";

const HeroBannerContainer = styled.section`
  position: relative;

  height: 100vh;
  padding: 30px;
  box-sizing: border-box;

  & .hero-image {
    position: relative;

    width: 100%;
    height: 100%;

    & .gatsby-image-wrapper {
      width: 100%;
      height: 100%;
    }

    & img:not([aria-hidden="true"]) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    & .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      background-color: #000;
    }
  }

  & .hero-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    z-index: 2;
    width: 100%;
    box-sizing: border-box;
    padding: 0 70px;

    text-align: center;
    color: #fff;

    & .subtitle {
      margin: 0 0 22px 0;
    }

    & .title {
      & h1,
      & h2,
      & h3 {
        margin: 0;
      }

      & h1 {
        font-size: 70px;
        line-height: 70px;

        @media (max-width: 1445px) {
          font-size: 60px;
          line-height: 65px;
        }

        @media (max-width: 999px) {
          font-size: 30px;
          line-height: 40px;
        }
      }

      & h2 {
        font-size: 45px;
        line-height: 50px;

        @media (max-width: 1445px) {
          font-size: 40px;
          line-height: 45px;
        }

        @media (max-width: 999px) {
          font-size: 24px;
          line-height: 32px;
        }
      }

      & h3 {
        font-size: 30px;
        line-height: 38px;

        @media (max-width: 1445px) {
          font-size: 28px;
          line-height: 34px;
        }

        @media (max-width: 999px) {
          font-size: 20px;
          line-height: 28px;
        }
      }
    }

    @media (max-width: 800px) {
      padding: 0 25px;
    }
  }
`;

export const HeroBanner = ({ content, index }) => {
  const image = content.primary.hero_image;
  const title = content.primary.title1;
  const subtitle = content.primary.subtitle;

  // Black overlay opacity (Prismic Number 0–100), clamped to a 0–1 range.
  const overlayOpacity =
    Math.min(100, Math.max(0, content.primary.overlay_opacity || 0)) / 100;

  return (
    <HeroBannerContainer className="module hero-banner">
      <div className="hero-image">
        {image?.gatsbyImageData && (
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={image.alt !== null ? image.alt : ``}
            style={{ height: `100%` }}
            objectFit="cover"
            fetchpriority={index <= 1 ? `high` : ``}
            loading={index <= 1 ? `eager` : `lazy`}
          />
        )}

        {overlayOpacity > 0 && (
          <div className="hero-overlay" style={{ opacity: overlayOpacity }} />
        )}
      </div>

      <div className="hero-content">
        {subtitle && (
          <p className="subtitle tag gotham-bold uppercase">{subtitle}</p>
        )}

        <div className="title">
          <PrismicRichText
            field={title?.richText}
            components={{
              heading1: ({ children }) => <h1>{children}</h1>,
              heading2: ({ children }) => <h2>{children}</h2>,
              heading3: ({ children }) => <h3>{children}</h3>,
            }}
          />
        </div>
      </div>
    </HeroBannerContainer>
  );
};
